<div class="kw-page" [class.map-popup]="this.isMapPopup" [nbSpinner]="this.isLoading">

  <ng-container *ngIf="!this.isMapPopup">
    <div class="kw-page-header">
      <div class="title-block">
        <h2 class="page-title">{{"Product" | tenantWords}} Summary</h2>
        <span class="page-subtitle">On-hand quantity by {{"Product" | tenantWords}}, {{"Location" | tenantWords}}, and lot</span>
      </div>
      <div class="header-actions">
        <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="exportExcel()">
          <fa-icon [icon]="faFileExcel" class="me-2"></fa-icon>Export
        </button>
      </div>
    </div>

    <div class="filters-bar">
      <kw-filter-dropdown class="filter-widget" [filterSettings]="this.dropdownSettings"
        (filterResultsChange)="setFilterResults($event)">
      </kw-filter-dropdown>
    </div>
  </ng-container>

  <div class="grid-card">
    <ejs-grid #grid *ngIf="!this.isLoading" [dataSource]="this.rows" [columns]="this.columns"
      [allowPaging]="true" [pageSettings]="this.pageSettings" [allowSorting]="true"
      [allowFiltering]="true" [filterSettings]="this.filterSettings" [allowTextWrap]="true"
      [enableStickyHeader]="true" [enableHover]="true" [allowExcelExport]="true"
      [aggregates]="this.aggregates"
      (actionBegin)="actionBegin($event)" (dataBound)="onDataBound()" (rowSelected)="onRowSelected($event)">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let row of this.rows | slice:0:mobileVisibleCount; trackBy: trackByRow" (click)="openLotDashboard(row)">
      <div class="m-card-top">
        <span class="m-card-name">{{row.name}}</span>
        <span class="type-pill">{{row.inventoryQuantity | number}} on hand</span>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="row.warehouseName || row.roomName">
          <fa-icon [icon]="faWarehouse" class="m-meta-icon"></fa-icon>{{row.warehouseName}}<ng-container *ngIf="row.warehouseName && row.roomName"> · </ng-container>{{row.roomName}}
        </div>
        <div class="m-meta-line">
          <fa-icon [icon]="faLocationDot" class="m-meta-icon"></fa-icon>{{row.locationName}}
        </div>
      </div>

      <div class="m-attrs" *ngIf="row.attributeValues.length">
        <span class="m-attr" *ngFor="let attribute of row.attributeValues">
          <span class="m-attr-name">{{attribute.name}}</span> {{attribute.value}}
        </span>
      </div>

      <div class="m-card-foot">
        <span class="m-card-note" *ngIf="row.lotNumber">
          <fa-icon [icon]="faTag" class="me-1"></fa-icon>Lot {{row.lotNumber}}
        </span>
        <div class="m-card-actions">
          <button mat-icon-button aria-label="Open lot dashboard" (click)="openLotDashboard(row); $event.stopPropagation()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.rows.length && !this.isLoading">
      <fa-icon [icon]="faBoxes" class="m-empty-icon"></fa-icon>
      <div>No {{"Products" | tenantWords}} match your filters</div>
    </div>

    <button class="m-show-more" *ngIf="this.rows.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.rows.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>

<ng-template #locationTemplate let-data>
  <span *ngIf="data.locationName === unassignedLocation; else locationName" class="type-pill empty">{{data.locationName}}</span>
  <ng-template #locationName>{{data.locationName}}</ng-template>
</ng-template>

<ng-template #actionTemplate let-data>
  <fa-icon [icon]="faChevronRight" class="row-chevron"></fa-icon>
</ng-template>
